export const data = [
  {
    title: {
      pt: "Projeto C-LAB",
      eng: "C-LAB Project",
    },
    subject: {
      pt: "Desenvolvimento de Software",
      eng: "Software Development",
    },
    description: {
      pt: '',
      eng: "Internal tool for comparison and management of different engines' results across multiple companies"
    },
    icon: "softdev",
    image: "clab.png",
    route: "clab",
    sub: "Software Development",
  },
  {
    title: {
      pt: "Tese de Mestrado (ABI na Saúde)",
      eng: "Master's Thesis (ABI in Healthcare)",
    },
    subject: {
      pt: "Desenvolvimento de Software",
      eng: "Software Development",
    },
    description: {
      pt: '',
      eng: 'Interoperability System for integrating ABI systems in Healthcare environments.'
    },
    icon: "softdev",
    image: "abi_thesis.png",
    route: "abi_thesis",
    sub: "Software Development",
  },
  {
    title: {
      pt: "Doppelganger",
      eng: "Doppelganger",
    },
    subject: {
      pt: "Desenvolvimento de Software",
      eng: "Software Development",
    },
    description: {
      pt: '',
      eng: 'Platform to compare code bases, calculate similarity, and minimize redundancy.'
    },
    icon: "softdev",
    image: "doppelganger.png",
    route: "doppelganger",
    sub: "Software Development",
  },
  {
    title: {
      pt: "GuedesMoney",
      eng: "GuedesMoney",
    },
    subject: {
      pt: "Desenvolvimento de Software",
      eng: "Software Development",
    },
    description: {
      pt: '',
      eng: 'A CLI interface for interacting with Portal das Finanças automatically and programmatically'
    },
    icon: "softdev",
    image: "guedesmoney.png",
    route: "guedesmoney",
    sub: "Software Development",
  },
  {
    title: {
      pt: "Sueca Online",
      eng: "Sueca Websocket Game",
    },
    subject: {
      pt: "Desenvolvimento Web",
      eng: "Web Development",
    },
    description: {
      pt: '',
      eng: 'The popular card game Sueca faithfully recreated using WebSockets for server-client real time communication'
    },
    icon: "webdev",
    image: "sueca.png",
    route: "sueca",
    sub: "Web Development",
  },
  {
    title: {
      pt: "Integração Jira TFS",
      eng: "QA Integration",
    },
    subject: {
      pt: "Integração de Sistemas",
      eng: "System Integration",
    },
    description: {
      pt: '',
      eng: 'Integration Platform between Jira and Microsoft Devops(TFS) systems for item migration, QA evaluation and work management.'
    },
    icon: "int",
    image: "qaint.png",
    route: "qaint",
    sub: "Web Development",
  },
  {
    title: {
      pt: "Website Pessoal",
      eng: "Personal Website",
    },
    subject: {
      pt: "Desenvolvimento Web",
      eng: "Web Development",
    },
    description: {
      pt: "Este é o meu portfolio web pessoal desenhado e construido do zero, que apresenta todos os meus projetos académicos/pessoais e informações profissionais relevantes de uma forma interativa",
      eng: "My personal Website where all my professional information, my personal and academic projects are stored and documented in an interactive way",
    },
    icon: "webdev",
    image: "personal-website.png",
    route: "personalweb",
    sub: "Web Development",
  },
  {
    title: {
      pt: "Previsões em R",
      eng: "Time Series Forecasting",
    },
    subject: {
      pt: "Machine Learning",
      eng: "Machine Learning",
    },
    description: {
      pt: "Este aplicativo foi construído usando a linguagem de programação R para prever com precisão o número de visitas que um shopping teria em uma determinada semana para que as campanhas de marketing apropriadas fossem configuradas durante cada dia.",
      eng: "This app was built to predict the number of visits a Mall would have in a certain week so the appropriate marketing campaigns would be set up during each day.",
    },
    icon: "ml",
    image: "rForecasting.png",
    route: "tsf",
    sub: "Machine Learning",
  },
  {
    title: {
      pt: "Preditor ESRB",
      eng: "ESRB Predictor",
    },
    subject: {
      pt: "Machine Learning",
      eng: "Machine Learning",
    },
    description: {
      pt: "Este aplicativo foi construído usando a linguagem de programação R para prever com precisão o número de visitas que um shopping teria em uma determinada semana para que as campanhas de marketing apropriadas fossem configuradas durante cada dia.",
      eng: "App that can accurately predict the ESRB Rating of a video game based on its content flags",
    },
    icon: "ml",
    image: "esrbpredictor.png",
    route: "esrbpred",
    sub: "Machine Learning",
  },
  {
    title: {
      pt: "Balanceamento de Carga de Servidores",
      eng: "Web Server Load Balancing",
    },
    subject: {
      pt: "Infraestrutura e Redes",
      eng: "Networking and Infrastructure",
    },
    description: {
      pt: "Este aplicativo foi construído usando a linguagem de programação R para prever com precisão o número de visitas que um shopping teria em uma determinada semana para que as campanhas de marketing apropriadas fossem configuradas durante cada dia.",
      eng: "Containerized automatic system that balances webserver load between a scalable cluster's instances of a service and keeps comunication private inside dedicated networks.",
    },
    icon: "netinf",
    image: "loadbalancer.png",
    route: "traefik",
    sub: "Networking",
  },

  {
    title: {
      pt: "SmartFood/FoodExpress",
      eng: "SmartFood/FoodExpress",
    },
    subject: {
      pt: "Machine Learning",
      eng: "Machine Learning",
    },
    description: {
      pt: "Este aplicativo foi construído usando a linguagem de programação R para prever com precisão o número de visitas que um shopping teria em uma determinada semana para que as campanhas de marketing apropriadas fossem configuradas durante cada dia.",
      eng: "Knowledge Based System that recommends dishes based on the user's preferences and finds the optimal route for the delivery boy",
    },
    icon: "ml",
    image: "sbc.png",
    route: "sbc",
    sub: "Machine Learning",
  },

  {
    title: {
      pt: "Rede Social SD",
      eng: "SD Social App",
    },
    subject: {
      pt: "Machine Learning",
      eng: "Network Programming",
    },
    description: {
      pt: "Este aplicativo foi construído usando a linguagem de programação R para prever com precisão o número de visitas que um shopping teria em uma determinada semana para que as campanhas de marketing apropriadas fossem configuradas durante cada dia.",
      eng: "Twitter-like social app and distributed system based on java sockets focused on traffic rules and flow over the network",
    },
    icon: "netprog",
    image: "sd.png",
    route: "sd",
    sub: "Networking",
  },

  {
    title: {
      pt: "Dívidas",
      eng: "Debts",
    },
    subject: {
      pt: "webdev",
      eng: "Web Development",
    },
    description: {
      pt: "Este aplicativo foi construído usando a linguagem de programação R para prever com precisão o número de visitas que um shopping teria em uma determinada semana para que as campanhas de marketing apropriadas fossem configuradas durante cada dia.",
      eng: "Progressive Web Application (PWA) built with MERN that allows users to record all debts and borrowed money between groups of friends and makes trip budget divisions easy",
    },
    icon: "webdev",
    image: "debts.png",
    route: "debts",
    sub: "Web Development",
  },

  {
    title: {
      pt: "SP Mobile",
      eng: "SP Mobile",
    },
    subject: {
      pt: "int",
      eng: "Technology Integration",
    },
    description: {
      pt: "Este aplicativo foi construído usando a linguagem de programação R para prever com precisão o número de visitas que um shopping teria em uma determinada semana para que as campanhas de marketing apropriadas fossem configuradas durante cada dia.",
      eng: "Progressive Web Application (PWA) that automates and integrates 3 different platforms (with different code basis and systems) into one via ERPs/CRMs and Web Services and APIs",
    },
    icon: "int",
    image: "isi.png",
    route: "isi",
    sub: "Web Development",
  },

  {
    title: {
      pt: "Titanic Kaggle",
      eng: "Titanic Kaggle",
    },
    subject: {
      pt: "int",
      eng: "Machine Learning",
    },
    description: {
      pt: "Este aplicativo foi construído usando a linguagem de programação R para prever com precisão o número de visitas que um shopping teria em uma determinada semana para que as campanhas de marketing apropriadas fossem configuradas durante cada dia.",
      eng: "Data Science project focused on studying and relating the features of the people aboard the titanic and their probability of death",
    },
    icon: "ml",
    image: "titanic.png",
    route: "titanic",
    sub: "Machine Learning",
  },
  {
    title: {
      pt: "guedesDB",
      eng: "guedesDB",
    },
    subject: {
      pt: "int",
      eng: "Software Development",
    },
    description: {
      pt: "Este aplicativo foi construído usando a linguagem de programação R para prever com precisão o número de visitas que um shopping teria em uma determinada semana para que as campanhas de marketing apropriadas fossem configuradas durante cada dia.",
      eng: "Data Science project focused on studying and relating the features of the people aboard the titanic and their probability of death",
    },
    icon: "softdev",
    image: "guedesdb.png",
    route: "guedesdb",
    sub: "Software Development",
  },
  {
    title: {
      pt: "TicTacBoom",
      eng: "TicTacBoom",
    },
    subject: {
      pt: "int",
      eng: "Web Development",
    },
    description: {
      pt: "Este aplicativo foi construído usando a linguagem de programação R para prever com precisão o número de visitas que um shopping teria em uma determinada semana para que as campanhas de marketing apropriadas fossem configuradas durante cada dia.",
      eng: "Web version of the fun game TicTacBoom that can be played anywhere with only a Smartphone",
    },
    icon: "webdev",
    image: "tictac.png",
    route: "tictac",
    sub: "Web Development",
  },
  {
    title: {
      pt: "BracelHertz",
      eng: "BracelHertZ",
    },
    subject: {
      pt: "int",
      eng: "Web Development",
    },
    description: {
      pt: "Este aplicativo foi construído usando a linguagem de programação R para prever com precisão o número de visitas que um shopping teria em uma determinada semana para que as campanhas de marketing apropriadas fossem configuradas durante cada dia.",
      eng: "BracelHertZ is an management Progressive Web Application designed to help lower prison suicide rates letting them monitor the inmates' heart rate.",
    },
    icon: "webdev",
    image: "bracelhertz.png",
    route: "bracelhertz",
    sub: "Web Development",
  },
  {
    title: {
      pt: "Press&Play",
      eng: "Press&play",
    },
    subject: {
      pt: "int",
      eng: "Web Development",
    },
    description: {
      pt: "Este aplicativo foi construído usando a linguagem de programação R para prever com precisão o número de visitas que um shopping teria em uma determinada semana para que as campanhas de marketing apropriadas fossem configuradas durante cada dia.",
      eng: "Progressive Web Application that allows people to schedule and reserve football games in fields all across Portugal.",
    },
    icon: "webdev",
    image: "pressplay.png",
    route: "pressplay",
    sub: "Web Development",
  },
  {
    title: {
      pt: "WorldWide BI",
      eng: "WorldWide BI",
    },
    subject: {
      pt: "webdev",
      eng: "Data Science",
    },
    description: {
      pt: "Este aplicativo foi construído usando a linguagem de programação R para prever com precisão o número de visitas que um shopping teria em uma determinada semana para que as campanhas de marketing apropriadas fossem configuradas durante cada dia.",
      eng: "Data Science project meant to study Natural Disasters and extract useful information from huge amounts of data."
    },
    icon: "datascn",
    image: "tsg.png",
    route: "tsg",
    sub: "Machine Learning",
  },
  {
    title: {
      pt: "Aventura do Fafense",
      eng: "Fafense Adventure",
    },
    subject: {
      pt: "gamedev",
      eng: "Game Development",
    },
    description: {
      pt: "Este aplicativo foi construído usando a linguagem de programação R para prever com precisão o número de visitas que um shopping teria em uma determinada semana para que as campanhas de marketing apropriadas fossem configuradas durante cada dia.",
      eng: "This game is a little game project, featuring a friend of mine saving his girlfriend, made for fun."
    },
    icon: "gamedev",
    image: "fafensead.png",
    route: "fafensead",
    sub: "Software Development",
  },

  {
    title: {
      pt: "Pequeno Eu",
      eng: "Little Me",
    },
    subject: {
      pt: "gamedev",
      eng: "Game Development",
    },
    description: {
      pt: "Este aplicativo foi construído usando a linguagem de programação R para prever com precisão o número de visitas que um shopping teria em uma determinada semana para que as campanhas de marketing apropriadas fossem configuradas durante cada dia.",
      eng: "Little me was a standalone project meant to be released to Steam. Later it was repurposed for a birthday gift to a friend."
    },
    icon: "gamedev",
    image: "little.png",
    route: "little",
    sub: "Software Development",
  },
];

export const typelist = [
  "All",
  "Web Development",
  "Machine Learning",
  "Networking",
  "Software Development",
];
